import { SortAscending, CaretDown, X, MoneyWavy } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";

interface SortFilterBarProps {
  sortLabel?: string;
  onSortClick?: () => void;
  filterActive: boolean;
  filterLabel?: string;
  onFilterClick?: () => void;
  onFilterClear?: () => void;
}

export const SortFilterBar = ({
  sortLabel = "Sort",
  onSortClick,
  filterActive,
  filterLabel,
  onFilterClick,
  onFilterClear,
}: SortFilterBarProps) => (
  <div className="flex gap-2 items-start px-4 py-1.5 overflow-x-scroll scrollbar-hide">
    <button
      type="button"
      onClick={onSortClick}
      className="bg-white hover:bg-shade-4 flex min-h-[28px] items-center gap-1 px-1.5 rounded-md shadow-[0px_0px_0px_1px_rgba(10,13,18,0.1),0px_1px_2px_0px_rgba(10,13,18,0.05)]">
      <Icon IconComponent={SortAscending} size="xs" iconProps={{ className: "text-iron" }} />
      <span className="text-text-sm-medium text-iron whitespace-nowrap">{sortLabel}</span>
      <Icon IconComponent={CaretDown} size="xxxs" iconProps={{ className: "text-zinc-400", weight: "fill" }} />
    </button>
    <div
      className={`bg-white hover:bg-shade-4 flex min-h-[28px] items-center rounded-md  ${
        filterActive
          ? "shadow-[0px_0px_0px_1.5px_var(--flo-primary-dark-color),0px_1px_2px_0px_rgba(10,13,18,0.05)]"
          : "shadow-[0px_0px_0px_1px_rgba(10,13,18,0.1),0px_1px_2px_0px_rgba(10,13,18,0.05)]"
      }`}>
      <button type="button" onClick={onFilterClick} className="flex items-center gap-1 pl-1.5 pr-1">
        <Icon
          IconComponent={MoneyWavy}
          size="xs"
          iconProps={{ className: filterActive ? "text-primary-dark" : "text-iron" }}
        />
        <span
          className={`text-text-sm-medium whitespace-nowrap ${
            filterActive ? "text-primary-dark" : "text-iron"
          }`}>
          {filterActive && filterLabel ? filterLabel : "Price"}
        </span>
        <Icon
          IconComponent={CaretDown}
          size="xxxs"
          iconProps={{ className: filterActive ? "text-primary-dark" : "text-zinc-400",weight:"fill" }}
        />
      </button>
      {filterActive && (
        <button
          type="button"
          onClick={onFilterClear}
          /* self-stretch, not h-full: the parent's height is auto, so a % height has no basis to
             resolve against, and its items-center would block the stretch anyway. rounded-r-md
             because the parent pill is not overflow-hidden — square corners would escape it. */
          className="bg-primary-alpha08  border-l border-black/[0.08] self-stretch rounded-r-md px-1.5 flex items-center justify-center ">
          <Icon IconComponent={X} size="xxxs" iconProps={{ color: "var(--flo-primary-dark-color)",weight:'bold' }} />
        </button>
      )}
    </div>
  </div>
);
